<template>
  <a-form class="search-form">
    <slot></slot>
  </a-form>
</template>

<script>
export default {
  name: 'SearchWrapper',
};
</script>

<style lang="less">
.search-form {
  padding: @padding-lg @padding-lg 0 @padding-lg;
  background: #ffffff;
  box-shadow: @box-shadow-base;
  border-radius: @border-radius-base;
  margin-bottom: @padding-xl;
  .ant-form-item {
    display: flex;
    label:after {
      content: '';
      margin: 0;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
    &.operation-group {
      margin-bottom: @padding-lg;
    }
  }
  .reset-btn {
    margin-left: @padding-md;
  }
  .more-conditions {
    margin-left: @padding-md;
    color: inherit;
  }
}
</style>
